import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { useConversationRow } from '../../../utils/useConversationRow';
import styles from './conversationsTableQueue.module.scss';
/** Represents the content of the queue cell in the conversations table. */
export const ConversationsTableQueue = () => {
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    // TODO: Implement  presentation
    return (_jsx(FlexBox, Object.assign({ alignItems: "center" }, { children: conversation.queue ? (conversation.queue.name) : (_jsx("em", Object.assign({ className: styles.notInQueue }, { children: "Not in a queue" }))) })));
};
